import * as React from "react";
import { Image, View, TouchableOpacity } from "react-native";
import { Feather } from "@expo/vector-icons";

export default function (props) {
  return (
    <>
      <View
        style={{
          height: 100,
          flexDirection: "row",
          justifyContent: "center",
        }}>
        {props.navigation && (
          <TouchableOpacity
            style={{ position: "absolute", left: 7, top: 35, zIndex: 999 }}
            onPress={() => {
              props.navigation.goBack();
            }}>
            <Feather name='arrow-left' size={30} color='#3E4672' />
          </TouchableOpacity>
        )}
        <Image
          resizeMode='contain'
          style={{
            alignSelf: "center",

            height: 80,
            width: "100%",
          }}
          source={require("../assets/images/Logo.png")}></Image>
      </View>
    </>
  );
}
